// extracted by mini-css-extract-plugin
module.exports = {"text-regular":"14px","list":"ListLinks-module--list--4bf07e","item":"ListLinks-module--item--407aa4","link":"ListLinks-module--link--205474"};